import { gql } from '@apollo/client'

export const MY_SESSIONS_QUERY = gql`
  query MY_SESSIONS_QUERY {
    mySessions {
      ok
      data {
        sessions {
          id
          ipAddress
          deviceLabel
          lastActiveAt
          createdAt
          isCurrent
        }
      }
    }
  }
`
